import { DuckdbConnectionType, WarehouseTypes, } from './projects';
const MULTI_CONNECTION_SUPPORT = {
    [WarehouseTypes.BIGQUERY]: false,
    [WarehouseTypes.POSTGRES]: true,
    [WarehouseTypes.REDSHIFT]: false,
    [WarehouseTypes.SNOWFLAKE]: true,
    [WarehouseTypes.DATABRICKS]: false,
    [WarehouseTypes.TRINO]: false,
    [WarehouseTypes.CLICKHOUSE]: false,
    [WarehouseTypes.ATHENA]: true,
    [WarehouseTypes.DUCKDB]: false,
};
const USER_CONNECTABLE_DUCKDB_TYPES = {
    [DuckdbConnectionType.MOTHERDUCK]: true,
    [DuckdbConnectionType.DUCKLAKE]: true,
    [DuckdbConnectionType.EMBEDDED]: false,
    [DuckdbConnectionType.ANALYTICS]: false,
};
export const isUserConnectableWarehouseConnection = (credentials) => credentials.type !== WarehouseTypes.DUCKDB ||
    USER_CONNECTABLE_DUCKDB_TYPES[credentials.connectionType];
export const MULTI_CONNECTION_WAREHOUSE_TYPES = Object.values(WarehouseTypes).filter((type) => MULTI_CONNECTION_SUPPORT[type]);
export const MIXED_TYPE_EXTRA_CONNECTION_WAREHOUSE_TYPES = Object.values(WarehouseTypes);
export const supportsMultipleConnections = (warehouseType, mixedTypesEnabled) => warehouseType !== null &&
    (mixedTypesEnabled
        ? MIXED_TYPE_EXTRA_CONNECTION_WAREHOUSE_TYPES.includes(warehouseType)
        : MULTI_CONNECTION_SUPPORT[warehouseType]);
export const canUseExtraConnectionWarehouseType = ({ originalWarehouseType, extraWarehouseType, mixedTypesEnabled, }) => supportsMultipleConnections(originalWarehouseType, mixedTypesEnabled) &&
    (mixedTypesEnabled || originalWarehouseType === extraWarehouseType) &&
    supportsMultipleConnections(extraWarehouseType, mixedTypesEnabled);
const DATABASE_LISTING_WAREHOUSE_TYPES = [
    WarehouseTypes.POSTGRES,
    WarehouseTypes.ATHENA,
];
export const supportsConnectionDatabaseListing = (warehouseType) => DATABASE_LISTING_WAREHOUSE_TYPES.includes(warehouseType);
export const WAREHOUSE_CONNECTION_NAME_MAX_LENGTH = 100;
export const WAREHOUSE_CONNECTION_NAME_CONFLICT_MESSAGE = 'A connection with this name already exists in this project.';
export const validateWarehouseConnectionName = (name) => {
    const trimmedName = name.trim();
    if (trimmedName.length === 0)
        return 'Enter a name';
    if (trimmedName.length > WAREHOUSE_CONNECTION_NAME_MAX_LENGTH) {
        return `Name must be ${WAREHOUSE_CONNECTION_NAME_MAX_LENGTH} characters or fewer`;
    }
    return null;
};
//# sourceMappingURL=warehouseConnections.js.map